import styled from "styled-components";

export const SafeSpace = styled.div`
  height: 0px;
  width: 100vw;
  background-color: transparent;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin: auto;
  width: 1148px;
  height: 100%;
  z-index: 99;
  position: relative;
  top: 100px;

  @media screen and (max-width: 768px) {
    width: 100%;
    height: 100%;
    top: 60px;
    padding-bottom: 100px;
  }
`;

export const Content = styled.div`
  @media screen and (min-width: 768px) {
    display: flex;
    justify-content: center;
    width: 1016px;
  }
`;

export const Section = styled.div`
  padding-left: 20px;

  @media screen and (min-width: 768px) {
    margin-left: 350px;
    max-width: 1016px;
    padding: unset;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  padding: 0 20px;

  @media screen and (min-width: 768px) {
    row-gap: 16px;
    padding: unset;
    margin-left: 66px;
    max-width: 1016px;
  }
`;

export const Title = styled.p`
  font-family: Gilroy;
  font-weight: 800;
  font-size: 40px;
  color: white;

  @media screen and (max-width: 768px) {
    font-size: 24px;
  }
`;

export const Description = styled.p`
  font-family: Gilroy;
  font-weight: 600;
  font-size: 20px;
  color: white;
  text-align: center;

  @media screen and (max-width: 768px) {
    font-size: 13px;
  }
`;

export const EmptySpace = styled.div<{ height: string }>`
  height: ${({ height }) => height || "40px"};
  background-color: transparent;
`;

export const SwooshContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 50%;
  height: 180px;

  img {
    width: 100%;
    height: 100%;
  }

  @media screen and (min-width: 768px) {
    width: 70%;
    height: 50%;
    img {
      width: unset;
    }
  }
`;
